var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.5,
    height: 15,
    viewBox: "0 0 12.5 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Delete",
    d: "M.625,14.375A.623.623,0,0,0,1.25,15h10a.623.623,0,0,0,.625-.625V3.75H.625ZM8.75,5.312A.276.276,0,0,1,9.062,5h.625A.276.276,0,0,1,10,5.312v8.125a.276.276,0,0,1-.312.313H9.062a.276.276,0,0,1-.312-.312Zm-3.125,0A.276.276,0,0,1,5.938,5h.625a.276.276,0,0,1,.312.313v8.125a.276.276,0,0,1-.312.313H5.938a.276.276,0,0,1-.313-.312Zm-3.125,0A.276.276,0,0,1,2.812,5h.625a.276.276,0,0,1,.313.313v8.125a.276.276,0,0,1-.313.313H2.812a.276.276,0,0,1-.312-.312ZM11.875,1.25H8.75V.625A.623.623,0,0,0,8.125,0H4.375A.623.623,0,0,0,3.75.625V1.25H.625A.623.623,0,0,0,0,1.875v1.25H12.5V1.875A.623.623,0,0,0,11.875,1.25Zm-3.75,0H4.375V.625h3.75Z",
    fill: "#666a70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.0579e18a0e952b98cfa1fcbaef929d8f.svg";
export { ForwardRef as ReactComponent };